<button
  class="thin-button"
  data-test-id="opportunity-actions-menu-clone"
  [appExpertClone]="experts"
  [opportunityId]="opportunity.opportunityId"
>
  CLONE
</button>
<button
  class="thin-button"
  data-test-id="opportunity-actions-menu-search"
  [routerLink]="['/admin', 'sourcing', 'cognisearch']"
  [queryParams]="{ opportunityId: opportunity.opportunityId }"
>
  SEARCH
</button>
<button
  class="thin-button"
  data-test-id="opportunity-actions-menu-upload-experts"
  [routerLink]="['/admin', 'manual-upload', opportunity.opportunityId]"
>
  UPLOAD
</button>
<button class="thin-button lg:hidden" data-test-id="opportunity-actions-menu-opportunity-dashboard">
  <a routerLink="../../../../dashboard"> PROJECT DASHBOARD </a>
</button>
<button class="thin-button lg:hidden" data-test-id="opportunity-actions-menu-client-portal">
  <a target="_blank" [href]="opportunity | portalLinks">PORTAL</a>
</button>
<button class="thin-button lg:hidden" data-test-id="opportunity-actions-menu-salesforce">
  <a target="_blank" [href]="opportunity | salesforceLinks">SALESFORCE</a>
</button>

<div class="more-actions" (appClickOutside)="closeMoreActionsMenu()">
  <mat-icon data-test-id="opportunity-actions-menu-overflow" (click)="toggleMoreActionsMenu()">more_vert</mat-icon>
  @if (moreActionsToggle) {
    <ul class="drop-down">
      <li class="drop-down-item lg:flex xl:hidden" routerLink="../../../../dashboard">
        <mat-icon class="drop-down-item-icon">subject</mat-icon>
        <span data-test-id="opportunity-actions-menu-opportunity-dashboard">Project dashboard</span>
      </li>
      <li class="drop-down-item flex" [routerLink]="['/admin', 'campaigns', opportunity.opportunityId]">
        <mat-icon class="drop-down-item-icon">campaign</mat-icon>
        <span data-test-id="opportunity-actions-menu-campaigns">Campaigns</span>
      </li>
      <li class="drop-down-item flex">
        <mat-icon class="drop-down-item-icon">language</mat-icon>
        <span data-test-id="opportunity-actions-menu-client-portal">
          <a target="_blank" [href]="opportunity | portalLinks">Portal</a></span
        >
        <mat-icon matTooltip="Copy to clipboard" class="interactable" [appCopyClientPortalLink]="opportunity">
          content_copy
        </mat-icon>
      </li>
      <li class="drop-down-item flex">
        <mat-icon class="drop-down-item-icon">backup</mat-icon>
        <span data-test-id="opportunity-actions-menu-salesforce">
          <a target="_blank" [href]="opportunity | salesforceLinks">Salesforce</a></span
        >
        <mat-icon matTooltip="Copy to clipboard" class="interactable" [copy-clipboard]="opportunity | salesforceLinks">
          content_copy
        </mat-icon>
      </li>
    </ul>
  }
</div>
